import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { TextInputControl } from 'components/_basic/Form/TextInput';
import { FormHeader } from 'components/_basic/FormHeader/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';

import { concatWithDot } from 'helpers/string';

import { prefix, WORKING_RESOURCES_NAMES } from './utils/form';

export const WorkingResources: React.FC = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.BUSINESS_OPERATIONS,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_BUSINESS_OPERATIONS.WORKING_RESOURCES,
  );

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t('businessOperations.title')}
          badgeText={t('businessOperations.workingResources.title')}
          section={FOR_BANK_SECTIONS.BUSINESS_OPERATIONS}
        />
      </FormSectionCard>
      {/* 6.5.1 */}
      <FormSectionCard
        disabled={!canAccess}
        title={t('businessOperations.workingResources.necessaryRecourses')}
        aiFieldName={concatWithDot(prefix, WORKING_RESOURCES_NAMES.NECESSARY_RECOURSES)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, WORKING_RESOURCES_NAMES.NECESSARY_RECOURSES)}
          name={concatWithDot(prefix, WORKING_RESOURCES_NAMES.NECESSARY_RECOURSES)}
          minRows={4}
          disabled={!canAccess}
          maxLength={1500}
        />
      </FormSectionCard>
      {/* 6.5.2 */}
      <FormSectionCard
        disabled={!canAccess}
        title={t('businessOperations.workingResources.availability')}
        aiFieldName={concatWithDot(prefix, WORKING_RESOURCES_NAMES.AVAILABILITY)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, WORKING_RESOURCES_NAMES.AVAILABILITY)}
          name={concatWithDot(prefix, WORKING_RESOURCES_NAMES.AVAILABILITY)}
          minRows={4}
          disabled={!canAccess}
          maxLength={1500}
        />
      </FormSectionCard>
    </>
  );
};
